import { State } from 'src/types'
import { flatWeb } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/web/flatWeb'
import { crossJointWeb, crossWeb, crossWebCenterStitch } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/web/crossWeb'
import { onePeaceWeb } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/web/onPeaceWeb'
import { vWeb } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/web/vWeb'
import { laceOfNetWeb } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/web/netWeb'
import { netWeb2 } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/web/netWeb2'
import { laceOfNetWebDouble, netWebDouble } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/web/netWebDouble'
import { crossDoubleWeb } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/web/crossDoubleWeb'
import { basketForPitcherWeb } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/web/basketWeb'
import { hJointWeb, hWeb } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/web/hWeb'
import {
  underWeb,
  underWebForNetWeb1,
  underWebForNetWeb2,
  underWebReinforcement
} from 'src/features/atoms/glove/drawer/rightThrow/glove/front/lace/underWeb'
import { fenceWeb } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/web/fenceWeb'
import { jointCheckerWeb } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/web/jointCheckerWeb'
import { netVWeb } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/web/netVWeb'
import { lacingNetWeb } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/web/lacingNetWeb'
import { hWeb2 } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/web/hWeb2'
import { laceOfNetWebDoubleWithJoint } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/web/newWebDoubleWithJoint'
import { indexWrapBack } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/lace/connectIndexToWeb'
import { w1Web } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/web/w1Web'
import { flatVLaceWeb } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/web/flatVLaceWeb'
import { netWeb3 } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/web/netWeb3'
import { w34Web } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/web/w34Web'
import { w36Web, w36WebCrossLace } from './w36Web'
import { w32Web } from './w32Web'
import { REINFORCEMENT_LACE_MODEL } from 'src/features/atoms/glove/japan/constants/baseModel'
import { webDrawUtil } from 'src/util/canvas'
import { w37Web } from './w37Web'
import { w38Web } from './w38Web'
import { w31Web } from './w31Web'

export const webOfGloveFrontDrawer = async (ctx: CanvasRenderingContext2D, state: State): Promise<void> => {
  const { webMatcher, webColor, web2Color, laceColor, stitchColor, edgeColor } = webDrawUtil(state)
  const printLeatherTypeValue = state.printLeatherType?.value
  if (webMatcher(['w1'])) await w1Web(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)
  if (webMatcher(['w3'])) await basketForPitcherWeb(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)
  if (webMatcher(['w4'])) await flatVLaceWeb(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)
  if (webMatcher(['w5'])) await flatWeb(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)
  if (webMatcher(['w6', 'w22', 'w29'])) await crossWebCenterStitch(ctx, laceColor, stitchColor, webColor, web2Color, printLeatherTypeValue)
  if (webMatcher(['w8', 'w10'])) await crossWeb(ctx, laceColor, stitchColor, webColor, web2Color, printLeatherTypeValue)
  if (webMatcher(['w9'])) await hWeb2(ctx, laceColor, stitchColor, webColor, web2Color, printLeatherTypeValue)
  if (webMatcher(['w11'])) await hWeb(ctx, laceColor, stitchColor, webColor, web2Color, printLeatherTypeValue)
  if (webMatcher(['w13'])) await lacingNetWeb(ctx, laceColor, stitchColor, webColor, web2Color, printLeatherTypeValue)
  if (webMatcher(['w14'])) await netWeb3(ctx, laceColor, stitchColor, webColor, web2Color, printLeatherTypeValue)
  if (webMatcher(['w17'])) await netWeb2(ctx, laceColor, stitchColor, webColor, web2Color, printLeatherTypeValue)
  if (webMatcher(['w19'])) await crossDoubleWeb(ctx, laceColor, stitchColor, webColor, web2Color, printLeatherTypeValue)
  if (webMatcher(['w20'])) await netVWeb(ctx, laceColor, stitchColor, webColor, web2Color, printLeatherTypeValue)
  if (webMatcher(['w23'])) await fenceWeb(ctx, laceColor, stitchColor, webColor, web2Color, printLeatherTypeValue)
  if (webMatcher(['w24'])) await onePeaceWeb(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)
  if (webMatcher(['w25'])) await netWebDouble(ctx, laceColor, stitchColor, webColor, web2Color, printLeatherTypeValue)
  if (webMatcher(['w26'])) await jointCheckerWeb(ctx, webColor, web2Color, laceColor, stitchColor, printLeatherTypeValue)
  if (webMatcher(['w27'])) await hJointWeb(ctx, laceColor, stitchColor, webColor, web2Color, printLeatherTypeValue)
  if (webMatcher(['w28'])) await crossJointWeb(ctx, laceColor, stitchColor, webColor, web2Color, printLeatherTypeValue)
  if (webMatcher(['w30'])) await vWeb(ctx, laceColor, stitchColor, webColor, web2Color, printLeatherTypeValue)
  if (webMatcher(['w31'])) await w31Web(ctx, laceColor, stitchColor, webColor, web2Color, printLeatherTypeValue)
  if (webMatcher(['w32'])) await w32Web(ctx, edgeColor, laceColor, stitchColor, webColor, web2Color, printLeatherTypeValue)
  if (webMatcher(['w33'])) await netWebDouble(ctx, laceColor, stitchColor, webColor, web2Color, printLeatherTypeValue)
  if (webMatcher(['w34'])) await w34Web(ctx, laceColor, stitchColor, webColor, web2Color, printLeatherTypeValue)
  if (webMatcher(['w36'])) await w36Web(ctx, edgeColor, laceColor, stitchColor, webColor, web2Color, printLeatherTypeValue)
  if (webMatcher(['w37'])) await w37Web(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)
  if (webMatcher(['w38'])) await w38Web(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)
}

export const rightLaceOfNetWebDrawer = async (ctx: CanvasRenderingContext2D, state: State): Promise<void> => {
  const printLeatherTypeValue = state.printLeatherType?.value
  const { webMatcher, webColor, web2Color, laceColor, stitchColor, productNumber } = webDrawUtil(state)
  if (webMatcher(['w14', 'w17'])) {
    underWeb(ctx, laceColor, 10, 0) // ウェブ下＿右
    underWeb(ctx, laceColor, -32, 64) // ウェブ下＿左
    indexWrapBack(ctx, laceColor, -10, -100) // 上
  }
  if (webMatcher(['w14', 'w17', 'w20'])) laceOfNetWeb(ctx, laceColor)
  if (webMatcher(['w33'])) await laceOfNetWebDouble(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)
  if (webMatcher(['w25'])) await laceOfNetWebDoubleWithJoint(ctx, laceColor, stitchColor, webColor, web2Color, printLeatherTypeValue)

  if (webMatcher(['w25', 'w33', 'w36'])) {
    underWebForNetWeb1(ctx, laceColor, 0, 0)
    underWebForNetWeb1(ctx, laceColor, -17, 30)
    underWebForNetWeb2(ctx, laceColor, -133, 95, -20)
    underWebForNetWeb2(ctx, laceColor, -15, 28, 0)
  }

  if (webMatcher(['w6', 'w8', 'w9', 'w10', 'w11', 'w19', 'w20', 'w22', 'w24', 'w27', 'w28', 'w29', 'w30', 'w31', 'w32', 'w34'])) {
    underWeb(ctx, laceColor, 10, 0) // ウェブ下＿右
    underWeb(ctx, laceColor, -32, 64) // ウェブ下＿左
    indexWrapBack(ctx, laceColor, -10, -100) // 上
    indexWrapBack(ctx, laceColor, 0, 0) // 下
  }
  if (webMatcher(['w23'])) {
    underWeb(ctx, laceColor, 27, -24) // ウェブ下＿右
    underWeb(ctx, laceColor, -2, 28) // ウェブ下＿中
    underWeb(ctx, laceColor, -35, 72) // ウェブ下＿左

    indexWrapBack(ctx, laceColor, -10, -100) // 上
    indexWrapBack(ctx, laceColor, 0, 0) // 下
  }
  if (webMatcher(['w1', 'w3', 'w4', 'w5', 'w13', 'w26', 'w37', 'w38'])) {
    underWeb(ctx, laceColor, 27, -24) // ウェブ下＿右
    underWeb(ctx, laceColor, -2, 28) // ウェブ下＿中
    underWeb(ctx, laceColor, -35, 72) // ウェブ下＿左
    indexWrapBack(ctx, laceColor, -10, -100) // 上
    indexWrapBack(ctx, laceColor, -4, -40) // 中
    indexWrapBack(ctx, laceColor, 3, 20) // 下
  }

  if (webMatcher(['w36'])) {
    await laceOfNetWebDouble(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)
    w36WebCrossLace(ctx, laceColor)
  }
  if (REINFORCEMENT_LACE_MODEL.includes(productNumber) && !webMatcher(['w13', 'w14', 'w25', 'w26', 'w36'])) underWebReinforcement(ctx, laceColor)
  if (webMatcher(['w28', 'w29', 'w30', 'w31', 'w34'])) underWebReinforcement(ctx, laceColor) // 捕球面の補強レース
}
